module.exports = __webpack_public_path__ + "img/discord.cdd0fa34.svg";